// extracted by mini-css-extract-plugin
export default {"cta":"kF-z","disabled":"lF-z"};